/**
 * Build-time configuration.
 *
 * Vite inlines these at build time — there is no server to read them at
 * runtime, so a containerised frontend has to be rebuilt (or built with
 * different args) to point at a different API.
 *
 * Both the VITE_ and the legacy REACT_APP_ names are read, so environments
 * configured for the Create React App build keep working; `envPrefix` in
 * vite.config.ts is what exposes the second set.
 */

/** Base URL of the API, including the `/api` prefix. */
export const API_URL =
  import.meta.env.VITE_API_URL ||
  import.meta.env.REACT_APP_API_URL ||
  'http://localhost:3000/api';

/** Socket.IO origin — the API host *without* the `/api` prefix. */
export const SOCKET_URL =
  import.meta.env.VITE_SOCKET_URL ||
  import.meta.env.REACT_APP_SOCKET_URL ||
  'http://localhost:3000';
